<template>
    <div :class="[isRenderedOnModal ? 'modal-rendered' : '', 'text-center px-2 py-5 success-page mt-5']">
        <img src="/homepage/images/checkmark.png" class="mb-4" alt="Checkmark icon"/>
        <h1 class="fw-500 mb-2 success-page__primary-heading">{{ determinePrimaryText }}</h1>
        <p class="text-dark-grey-1 fs-15 mb-4">{{ determineSecondaryText }}</p>

        <!-- Button container -->

        <div class="text-center">
          <SfeButton @click="$emit('show-login-form')" class="text-white btn btn-success px-5 d-inline-block">
            Login
          </SfeButton>
        </div>

		<!-- Button container -->
    </div>
</template>

<script>
    export default {
        props: {
            emailResetLinkSuccess: {
                type: Boolean,
                default: false
            },
            passwordResetSuccess: {
                type: Boolean,
                default: false
            },
            isRenderedOnModal: {
                type: Boolean,
                default: false
            },
            expiredPaswordReset: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            determinePrimaryText() {
                if (this.emailResetLinkSuccess) {
                    return 'Password reset link requested!'
                } 
                if (this.passwordResetSuccess) {
                    return `Password ${this.expiredPaswordReset ? 'reset successful' : 'created successfully' }`
                }
                return 'Success!'
            },
            determineSecondaryText() {
                if (this.emailResetLinkSuccess) {
                  return 'If the email provided is correct, we\'ll send a reset link any moment from now'
                } 
                if (this.passwordResetSuccess) {
                    return `${this.expiredPaswordReset ? 'Log in to gain access back to the system' : 'Login to continue your application process'}`
                }
                return 'Login to continue'
            }
        }
    }
</script>

<style lang="scss" scoped>
@media screen and (min-width: 320px) {
    .success-page {
        &__primary-heading {
            font-size: 24px;
        }
    }
}
@media screen and (min-width: 768px) {
    .success-page {
        min-height: 100vh;
        &.modal-rendered {
            min-height: 0;
        }
        &__primary-heading {
            font-size: 32px;
        }
    }
}
</style>